import api from './axios';

// Users API
export const usersAPI = {
  getAll: (params) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  getTeamMembers: () => api.get('/users/team-members'),
  create: (userData) => api.post('/users', userData),
  updateStatus: (id, isActive) => api.patch(`/users/${id}/status`, { isActive }),
  resetPassword: (id, password) => api.post(`/users/${id}/reset-password`, password ? { password } : {}),
  uploadSignature: (id, formData) => api.post(`/users/${id}/signature`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteSignature: (id) => api.delete(`/users/${id}/signature`)
};

export default usersAPI;
